import analytics from '@/utils/analytics/analyticsInstance';
import { useEffect } from 'react';

export const useTrackPageLoadTime = (eventName: string) => {
  useEffect(() => {
    const [navEntry] = performance.getEntriesByType('navigation') as PerformanceNavigationTiming[];

    if (navEntry) {
      const metrics = {
        domLoadTime: (navEntry.domContentLoadedEventEnd - navEntry.startTime) / 1000,
      };

      analytics.track(eventName, { loading_time: metrics.domLoadTime });
    }
  }, [eventName]);
};
